var map = {
	"./amplify-amazon-button_5.entry.js": [
		"77e1",
		"chunk-6e050c03"
	],
	"./amplify-auth-fields_9.entry.js": [
		"2689",
		"chunk-0e953d7d"
	],
	"./amplify-authenticator.entry.js": [
		"b836",
		"chunk-64e152b6"
	],
	"./amplify-button_3.entry.js": [
		"efa9",
		"chunk-43529756"
	],
	"./amplify-checkbox.entry.js": [
		"db86",
		"chunk-2d228cf2"
	],
	"./amplify-confirm-sign-in_8.entry.js": [
		"be17",
		"chunk-32c43406"
	],
	"./amplify-container.entry.js": [
		"a72f",
		"chunk-2d208de0"
	],
	"./amplify-federated-buttons_2.entry.js": [
		"644c",
		"chunk-1ec2497c"
	],
	"./amplify-federated-sign-in.entry.js": [
		"a81f",
		"chunk-1b54e3ba"
	],
	"./amplify-form-field_4.entry.js": [
		"f988",
		"chunk-2d22dbc9"
	],
	"./amplify-greetings.entry.js": [
		"57dd",
		"chunk-72159ded"
	],
	"./amplify-icon-button.entry.js": [
		"182d",
		"chunk-2d0abfcf"
	],
	"./amplify-icon.entry.js": [
		"b8f5",
		"chunk-e5baf7f0"
	],
	"./amplify-link.entry.js": [
		"f482",
		"chunk-2d22c8fe"
	],
	"./amplify-nav_2.entry.js": [
		"23a0",
		"chunk-333044df"
	],
	"./amplify-radio-button_2.entry.js": [
		"a4b9",
		"chunk-0e567776"
	],
	"./amplify-select-mfa-type.entry.js": [
		"fef4",
		"chunk-b1ce8bd4"
	],
	"./amplify-sign-in-button.entry.js": [
		"7358",
		"chunk-f9699e24"
	],
	"./amplify-tooltip.entry.js": [
		"1faa",
		"chunk-2d0b722b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "521b";
module.exports = webpackAsyncContext;